"use client";
import Link from "next/link";
import Container from "../components/container/Container";
import React, { useState } from "react";

const navLinks = [
  { href: "#home", label: "HOME", ariaLabel: "Scroll to Home" },
  { href: "#about", label: "ABOUT", ariaLabel: "Scroll to About" },
  { href: "#work", label: "WORK", ariaLabel: "Scroll to Work" },
  { href: "#jobs", label: "EXPERIENCE", ariaLabel: "Scroll to Experience" },
  { href: "#education", label: "EDUCATION", ariaLabel: "Scroll to Education" },
  { href: "#contact", label: "CONTACT", ariaLabel: "Scroll to Contact" },
];

export default function NavBar() {
  const [open, setOpen] = useState(false);

  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute("href")!.replace("#", "");
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <>
      {/* ── Desktop pill (sm+) ── */}
      <nav className="fixed bottom-10 left-0 right-0 z-50 mx-auto hidden w-auto items-center justify-center px-1 py-1 text-[#e4ded7] sm:flex sm:w-[383px] lg:w-[620px]">
        <Container
          width="100%"
          height="50px"
          color="rgba(255,255,255,0.1)"
          borderRadius={10}
          top="0px"
          left="0px"
          angle={0}
        >
          <nav className="flex w-full items-center justify-center gap-1 px-1 py-1">
            {navLinks.map(({ href, label, ariaLabel }) => (
              <Link
                key={href}
                href={href}
                onClick={scrollTo}
                aria-label={ariaLabel}
                data-blobity-magnetic="false"
              >
                <span className="block px-3 py-2 text-[12px] font-bold md:px-4 md:text-[14px]">
                  {label}
                </span>
              </Link>
            ))}
          </nav>
        </Container>
      </nav>

      {/* ── Mobile (below sm) ── */}
      <div style={{ position: "fixed", top: 24, right: 24, zIndex: 9999 }} className="sm:hidden">
        {/* Circle toggle button */}
        <button
          type="button"
          data-no-blobity
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((o) => !o)}
          style={{
            width: 52,
            height: 52,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.18)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            touchAction: "manipulation",
            WebkitTapHighlightColor: "transparent",
          }}
        >
          {open ? (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <line
                x1="1"
                y1="1"
                x2="15"
                y2="15"
                stroke="#e4ded7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="15"
                y1="1"
                x2="1"
                y2="15"
                stroke="#e4ded7"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          ) : (
            <svg width="18" height="12" viewBox="0 0 18 12" fill="none">
              <line
                x1="0"
                y1="1"
                x2="18"
                y2="1"
                stroke="#e4ded7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="0"
                y1="6"
                x2="18"
                y2="6"
                stroke="#e4ded7"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="0"
                y1="11"
                x2="18"
                y2="11"
                stroke="#e4ded7"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          )}
        </button>

        {/* Menu list — drops down below the button when open */}
        {open && (
          <div
            style={{
              position: "absolute",
              top: 60,
              right: 0,
              background: "rgba(255,255,255,0.08)",
              border: "1px solid rgba(255,255,255,0.12)",
              backdropFilter: "blur(12px)",
              WebkitBackdropFilter: "blur(12px)",
              borderRadius: 12,
              padding: "8px 4px",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              minWidth: 140,
            }}
          >
            {navLinks.map(({ href, label, ariaLabel }) => (
              <a
                key={href}
                href={href}
                aria-label={ariaLabel}
                onClick={scrollTo}
                style={{
                  display: "block",
                  textAlign: "center",
                  padding: "8px 20px",
                  fontSize: 12,
                  fontWeight: 700,
                  letterSpacing: "0.1em",
                  color: "#e4ded7",
                  borderRadius: 8,
                  textDecoration: "none",
                }}
              >
                {label}
              </a>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
